export const CHECKOUT_URL = 'https://blueprint.impultienda.ar/checkout/menopause'

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/38Bdv6C1Db6Su8JaUt1eNo/FERTILIDAD-2.png'

export const bonus1Image =
  'https://cdn.magicpatterns.com/uploads/9yz6ccC2DrjM3xjDSRJAGr/BONO_1_MENOPAUSIA-EN.png'

export const bonus2Image =
  'https://cdn.magicpatterns.com/uploads/t56s9QMahEcpEyKgMQf528/BONO_2_MENOPAUSIA-EN.png'

export const bonus3Image =
  'https://cdn.magicpatterns.com/uploads/q2zoSCWd8jcA2nbJhz4VBZ/BONO_3_MENOPAUSIA-EN.png'

export const bonus4Image =
  'https://cdn.magicpatterns.com/uploads/cxCWYtG7L7V8YKtnHiQ7xE/BONO_4_MENOPAUSIA-EN.png'

export const bonus5Image =
  'https://cdn.magicpatterns.com/uploads/16hUqmqXovvFE5DSxzwjFb/BONO_5_MENOPAUSIA-EN.png'

export const karitoPhoto =
  'https://cdn.magicpatterns.com/patterns/generated-images/c3d0e1f7-fc6a-4834-98c9-fd6074ea2048.jpg'

export const stats = [
  { value: '300+', label: 'Clinical Algorithms' },
  { value: '2,000+', label: 'Physicians Using the System' },
  { value: '1,500+', label: 'Hours Saved Every Year' },
  { value: '99%', label: 'Recommend It to Colleagues' },
]

export const patientScenarios = [
  'One patient has severe hot flashes.',
  'Another has a strong family history of breast cancer.',
  'Another presents with obesity and cardiovascular risk.',
  'Another develops unexpected bleeding after starting hormone therapy.',
]

export const steps = [
  {
    step: 'STEP 1',
    title: 'Quickly Identify the Right Candidate',
    body: 'Determine whether your patient is truly an appropriate candidate for Menopause Hormone Therapy using structured clinical algorithms.',
    highlights: ['No unnecessary testing.', 'No uncertainty.'],
  },
  {
    step: 'STEP 2',
    title: 'Assess Clinical Risk in Minutes',
    body: 'Evaluate cardiovascular, thromboembolic and breast cancer risk using practical evidence-based decision trees.',
    highlights: ['Know when treatment is appropriate.', "Know when it isn't."],
  },
  {
    step: 'STEP 3',
    title: 'Choose the Best Treatment',
    body: 'Select the right hormone. The right dose. The right delivery method. For the right patient.',
    highlights: ['Every time.'],
  },
  {
    step: 'STEP 4',
    title: 'Optimize Long-Term Outcomes',
    body: 'Know exactly what to monitor, when to follow up, when to adjust therapy, when to switch treatment and when to discontinue therapy.',
    highlights: ['Without relying on guesswork.'],
  },
]

export const beforeItems = [
  'Searching through multiple guidelines',
  'Uncertainty about hormone therapy candidacy',
  'Fear of making the wrong prescribing decision',
  'Inconsistent follow-up',
  'Long, complicated consultations',
  'Constant second-guessing',
]

export const afterItems = [
  'Following one structured clinical pathway',
  'Confident patient selection using clear algorithms',
  'Evidence-based treatment decisions',
  'Standardized monitoring protocols',
  'Faster, more efficient clinical visits',
  'Greater confidence in every clinical decision',
]

export const painPoints = [
  "You're unsure when to initiate Menopause Hormone Therapy.",
  'You hesitate between oral and transdermal treatment.',
  "You're uncertain how to manage patients with cardiovascular or breast cancer risk.",
  'You spend too much time reviewing multiple clinical guidelines.',
  'Patients ask difficult questions about hormone safety—and you wish your answers felt more confident.',
  'Every menopause consultation feels different, making it difficult to standardize your clinical approach.',
]

export type Volume = {
  number: string
  title: string
  lead: string
  body: string
  introList: string
  items: string[]
}

export const volumes: Volume[] = [
  {
    number: 'VOLUME 1',
    title: 'The Clinical Assessment Blueprint',
    lead: 'Learn how to identify the right patient before making your first treatment decision.',
    body: 'Develop a structured clinical approach for evaluating menopausal women using evidence-based assessment pathways.',
    introList: "Inside you'll learn:",
    items: [
      'Symptom evaluation',
      'Differential diagnosis',
      'Menopause staging',
      'Opportunity window',
      'Initial laboratory work-up',
      'Clinical assessment algorithms',
      'Real-world patient examples',
    ],
  },
  {
    number: 'VOLUME 2',
    title: 'The Risk Assessment Blueprint',
    lead: "Confidently determine who is—and isn't—a candidate for Menopause Hormone Therapy.",
    body: 'Stop guessing. Start making evidence-based risk assessments in minutes.',
    introList: "Inside you'll discover:",
    items: [
      'Cardiovascular risk assessment',
      'Breast cancer risk evaluation',
      'Venous thromboembolism screening',
      'Contraindications',
      'Patient selection',
      'Clinical safety algorithms',
      'Shared decision-making tools',
    ],
  },
  {
    number: 'VOLUME 3',
    title: 'The Hormone Therapy Playbook',
    lead: 'Select the right hormone, dose, and delivery method for every patient.',
    body: 'No more uncertainty when prescribing. Everything is organized into practical prescribing pathways.',
    introList: 'Includes:',
    items: [
      'Estrogen selection',
      'Progesterone selection',
      'Oral vs. transdermal therapy',
      'Vaginal hormone therapy',
      'Initial dosing',
      'Maintenance strategies',
      'Combination therapy',
      'Clinical prescribing algorithms',
    ],
  },
  {
    number: 'VOLUME 4',
    title: 'Treatment Optimization',
    lead: 'Know exactly when to adjust, switch, or discontinue therapy.',
    body: "Because successful hormone therapy doesn't end with the prescription. It requires continuous optimization.",
    introList: "You'll learn:",
    items: [
      'Managing side effects',
      'Dose adjustments',
      'Monitoring strategies',
      'Laboratory follow-up',
      'Therapy optimization',
      'Long-term management',
    ],
  },
  {
    number: 'VOLUME 5',
    title: 'Advanced Clinical Scenarios',
    lead: "Confidently manage patients who don't fit the standard protocol.",
    body: 'Learn how experienced menopause specialists approach complex cases.',
    introList: 'Including:',
    items: [
      'Breast cancer survivors',
      'Premature ovarian insufficiency',
      'Surgical menopause',
      'Cardiovascular disease',
      'Contraindications',
      'Failed hormone therapy',
      'Non-hormonal alternatives',
      'Challenging patient cases',
    ],
  },
  {
    number: 'VOLUME 6',
    title: 'The Physician Toolkit',
    lead: 'Everything you need to run a more organized, professional menopause practice.',
    body: 'Includes ready-to-use clinical resources:',
    introList: 'Inside:',
    items: [
      'Consultation templates',
      'Clinical checklists',
      'SOAP note templates',
      'Follow-up forms',
      'Patient education resources',
      'Informed consent documents',
      'Communication scripts',
      'Documentation tools',
    ],
  },
]

export type Bonus = {
  number: string
  title: string
  lead: string
  body?: string
  items?: string[]
  value: string
  image?: string
}

export const bonuses: Bonus[] = [
  {
    number: 'BONUS #1',
    title: 'Hormone Therapy Quick Reference Guide™',
    lead: 'Never waste time searching for dosing equivalencies again.',
    body: 'Quick-reference charts for medications, dosing conversions, delivery methods and prescribing recommendations.',
    value: '$47',
    image: bonus1Image,
  },
  {
    number: 'BONUS #2',
    title: 'Clinical Lab Interpretation Guide™',
    lead: 'Confidently interpret menopause-related laboratory tests in minutes.',
    body: 'Includes practical guidance for:',
    items: [
      'FSH',
      'Estradiol',
      'LH',
      'Testosterone',
      'SHBG',
      'Lipid Profile',
      'Bone Health',
      'Vitamin D',
      'Clinical decision algorithms',
    ],
    value: '$47',
    image: bonus2Image,
  },
  {
    number: 'BONUS #3',
    title: 'Difficult Patient Conversation Scripts™',
    lead: 'Know exactly what to say when patients ask difficult questions about hormone therapy.',
    body: 'Includes ready-to-use communication frameworks for discussions about:',
    items: [
      'Breast cancer',
      'Blood clots',
      'Cardiovascular risk',
      'Weight gain',
      'Hormone safety',
      'Risk vs. benefit conversations',
    ],
    value: '$67',
    image: bonus3Image,
  },
  {
    number: 'BONUS #4',
    title: 'Complication Management Playbook™',
    lead: 'Evidence-based algorithms for managing bleeding, side effects, poor symptom control and treatment failures.',
    body: "Know exactly what to do when therapy doesn't go as planned.",
    value: '$67',
    image: bonus4Image,
  },
  {
    number: 'BONUS #5',
    title: 'Clinical Documentation Toolkit™',
    lead: 'Professional templates designed to save time and improve documentation quality.',
    body: 'Includes:',
    items: [
      'Clinical forms',
      'SOAP Notes',
      'Follow-up templates',
      'Treatment plans',
      'Risk assessments',
      'Consent forms',
      'Documentation checklists',
    ],
    value: '$67',
    image: bonus5Image,
  },
]

export const valueRows = [
  { label: 'Menopause Clinical Blueprint™ (6 Volumes)', value: '$297' },
  { label: 'Hormone Therapy Quick Reference Guide™', value: '$47' },
  { label: 'Clinical Lab Interpretation Guide™', value: '$47' },
  { label: 'Difficult Patient Conversation Scripts™', value: '$67' },
  { label: 'Complication Management Playbook™', value: '$67' },
  { label: 'Clinical Documentation Toolkit™', value: '$67' },
]

export const testimonials = [
  {
    quote:
      'I stopped jumping between multiple guidelines. Everything I need is finally organized into one practical clinical system.',
    name: 'Dr. Sarah M.',
    role: 'OB-GYN • Texas, USA',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/1545b078-30c7-42da-8ea1-39d5dd65e0d6.jpg',
  },
  {
    quote:
      'The prescribing algorithms alone are worth several times the purchase price. I use them almost every day.',
    name: 'Dr. Michael R.',
    role: 'Family Physician • Ontario, Canada',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/3824653d-64ca-455c-bca9-6b4585742ca5.jpg',
  },
  {
    quote:
      'The communication scripts completely changed how I discuss hormone therapy with patients. Those difficult conversations are now much easier.',
    name: 'Dr. Emily T.',
    role: "Women's Health Physician • Australia",
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/f030fda7-4981-4b51-a962-9b0bc3a623ee.jpg',
  },
  {
    quote:
      "I expected another PDF. What I actually received was a clinical decision system I'll continue using throughout my practice.",
    name: 'Dr. James L.',
    role: 'Internal Medicine • United Kingdom',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/7b17f61f-567f-41a6-ba64-1e97e509a271.jpg',
  },
]

export const faqs = [
  {
    q: 'Is this appropriate for physicians outside the United States?',
    a: 'Yes. The content is based on internationally recognized clinical guidelines and can be applied in any healthcare setting.',
  },
  {
    q: 'Is this a one-time purchase?',
    a: 'Yes. Pay once and enjoy lifetime access.',
  },
  {
    q: 'Is everything downloadable?',
    a: 'Yes. All resources are delivered digitally for convenient access anytime.',
  },
  {
    q: 'Is the content updated?',
    a: 'Yes. The material reflects current evidence and guideline recommendations through 2026.',
  },
]

export const buyerNames = [
  'María González',
  'Carlos Ramírez',
  'Lucía Fernández',
  'Andrés Morales',
  'Valentina Rojas',
  'Javier Castillo',
  'Camila Herrera',
  'Diego Peña',
  'Sofía Martínez',
  'Ricardo Vargas',
  'Paula Navarro',
  'Fernando Ortiz',
  'Daniela Suárez',
  'Miguel Ángel Torres',
  'Gabriela Medina',
]

export const buyerCountries = [
  'Argentina',
  'México',
  'Colombia',
  'Chile',
  'Perú',
  'España',
  'Uruguay',
  'Ecuador',
  'Costa Rica',
  'Panamá',
  'República Dominicana',
  'Paraguay',
  'Guatemala',
  'Bolivia',
]
